<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <!-- {{ this.ferg() }} -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">Conexión</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div class="del_ctn">
                      <p>
                        <b>Habilitar:</b> Significa que el sensor recibirá datos
                        del controlador.
                      </p>
                      <p>
                        <b>Deshabilitar:</b>
                        El sensor dejara de recibir datos del controlador.
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      ref="state"
                      v-model="data.state"
                      :items="[true, false]"
                      label="Recibir dato del controlador"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == true ? "Habilitado" : "Deshabilitado" }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == true ? "Habilitado" : "Deshabilitado" }}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  class=""
                  color="primary"
                  :disabled="!valid"
                  depressed
                  large
                  @click="validate"
                  >Guardar</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "ConnectComp",
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
      name: null,
      nameRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
  },
  methods: {
    ...mapActions(["updateDevice", "QueryDevice", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async registerForm() {
      try {
        let updateAt = Date.now();
        let activate = this.data.state == true ? 1 : 0;
        let form = {
          _id: this.data._id,
          state: this.data.state,
          activate: activate,
          updateAt: updateAt,
        };
        let update = await this.updateDevice(form);
        await this.QueryDevice(this.data._id);
        this.$refs.form.reset();
        if (update == 200) {
          this.$root.$emit("reload"); // parametro update tabla

          this.alertSnackbar({
            snackbar: true,
            text: "Se ha desabilitado el dispositivo.",
          });
        }
        this.show = false;
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/base.scss";
.del_ctn {
  p {
    font-family: Roboto;
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>
